const VIP_TRANSFER_ENDPOINT = '/api/internal/vip-transfer';

export type VipTransferRequestError = Error & { status: number };

export const isVipTransferRequestError = (
  error: unknown
): error is VipTransferRequestError =>
  error instanceof Error &&
  typeof (error as { status?: unknown }).status === 'number';

export const sendVipTransferRequest = async (files: File[]): Promise<void> => {
  const formData = new FormData();

  files.forEach((file) => {
    formData.append('files', file);
  });

  const response = await fetch(VIP_TRANSFER_ENDPOINT, {
    method: 'POST',
    body: formData,
  });

  if (!response.ok) {
    const body = await response.json().catch(() => null);
    const message =
      body?.message ?? body?.error ?? `Request failed: ${response.status}`;
    throw Object.assign(new Error(message), { status: response.status });
  }
};
